import React, { useState, useEffect, useRef, Fragment } from "react";

// Librerias de componentes
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Password } from "primereact/password";
import { Dialog } from "primereact/dialog";
import { Divider } from "primereact/divider";
import { Accordion, AccordionTab } from "primereact/accordion";
import { TabPanel, TabView } from "primereact/tabview";
import { FileUpload } from "primereact/fileupload";
import { Carousel } from "primereact/carousel";
import { ConfirmDialog } from "primereact/confirmdialog";
import { Toast } from "primereact/toast";

import { toastShow } from "../../../../Services/ToastService";
import { encryptor } from "../../../../Services/Crypto/Crypto";
import { descargarFirma, eliminarFirma, mostrarFirma } from "../../../../API/IT/Imagenes/ImagenesRequest"; 
import { getRoles } from "../../../../API/IT/Roles/RolesRequests";
import { getEstadosCategory } from "../../../../../API/Global/Status/StatusRequests";
import { updateUser, updatePassword, getUsuarios, getFirmasPersonales } from "../../../../API/IT/Users/UserRequests";

import Loader from "../../../../Components/Loader/Loader";
import { useForm } from "../../../../Hooks/useForm";
import AutoCompleteDropdown from "../../../../Components/Form/AutoCompleteDropdown";
import { downloadFile, uploadHandlerFirma } from "../../../../Services/ArchivosService";
import { getPersonal } from "../../../../../API/RRHH/Personal/PersonalRequests";
import { getTypesCategoria } from "../../../../API/Global/Types/TypeRequest";
import { MultiSelect } from "primereact/multiselect";
import { getAreasAct } from "../../../../API/Global/Areas/AreasRequests";


export const ModalEditarUsuario = ({
  userEdit,
  getUsers,
  setuserEdit,
  modo,
  hiddenPassword
}) => {
  // Variables necesarias
  const [roles, setRoles] = useState([{}]);
  const [estados, setEstados] = useState([{}]);
  const [showDialog, setShowDialog] = useState(false);
  const [usuariosExistentes, setUsuariosExistentes] = useState([]);
  const [imagenAgregada, setImagenAgregada] = useState(false);
  const [listadoArchivos, setListadoArchivos] = useState([]);
  const fileUpload = useRef(null);
  const [imagenes, setImagenes] = useState([]);
  const [showModalImagenes, setShowModalImagenes] = useState(false);
  const [personal, setPersonal] = useState([]);
  const [areas, setAreas] = useState([]);


  const [usuarioDialog, setUsuarioDialog] = useState(false);
  const toast = useRef(null);


  const [loading1, setLoading1] = useState(false);
  const [types, setTypes] = useState([]);
  const [subTypes, setSubTypes] = useState([]);

  const initialValues = userEdit;

  const { values, handleInputChange, setValues, resetForm, error, setError } =
    useForm(initialValues);

  const getValoresIniciales = async () => {
    setLoading1(true);
    const personalTempo = await getPersonal()
    setPersonal(personalTempo)
    const rolesTempo = await getRoles();
    const estadosTempo = await getEstadosCategory("Users");
    const u = await getUsuarios();
    setUsuariosExistentes(u);
    setRoles(rolesTempo);
    setEstados(estadosTempo);

    const typesTempo = await getTypesCategoria('ActivoFijo');
    setTypes(typesTempo);

    const subTypesTempo = await getTypesCategoria('SubTipoActivo');
    setSubTypes(subTypesTempo);

    const sec = await getAreasAct();
    setAreas(sec);
    
    
    const areasSeleccionadas = Array.isArray(userEdit?.IdsAreas) ? userEdit.IdsAreas : typeof userEdit?.IdsAreas === 'string' ? userEdit.IdsAreas.split(',') .map(id => parseInt(id)) .map(id => sec.find(area => area.IdArea === id)) .filter(Boolean) : [];

    const estadoInicial =
      modo === "Crear"
        ? estadosTempo[0]
        : estadosTempo.find((e) => e.IdStatus === userEdit?.IdStatus);

    setValues({
      ...userEdit,
      Estado: estadoInicial,
      Roles: rolesTempo.find((t) => userEdit?.IdRol === t.IdRol),
      Personal: personalTempo.find((t) => userEdit?.IdPersonalInt === t.IdPersonal),
      Type: typesTempo.find((t) => userEdit?.IdTipoActivo === t.IdType),
      SubType: subTypesTempo.find((st) => userEdit?.IdSubTipoActivo === st.IdType),
      Areas: areasSeleccionadas
    });

    setLoading1(false);
  };

  const verificarInfo = (e) => {
    let error = {};
    if (!values.Usuario) {
      error.Usuario = true;
      error.error = true;
    }
    if (!values.UserName) {
      error.UserName = true;
      error.error = true;
    }
    if (!values.Estado || !values.Estado.IdStatus) {
      error.IdStatus = true;
      error.error = true;
    }
    if (!values.Roles || !values.Roles.IdRol) {
      error.IdRol = true;
      error.error = true;
    }
    // if (!values.Personal || !values.Personal.IdPersonal) {
    //   error.IdPersonal = true;
    //   error.error = true;
    // }
    if (values.Email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.Email)) {
      error.Email = true;
      error.error = true;
    }
    if (values.Password !== values.ConfirmarPassword) {
      error.Password = true;
      error.error = true;
    }
    setError(error);
    // console.log(error);
    return error;
  };

  // Funcion de para editar un nuevo usuario
  const editarUsuario = async () => {
    const e = verificarInfo();

    if (!e.error) {
      const user = {
        Usuario: values?.Usuario,
        // UserName: values.UserName.toLowerCase().replace(/\b\w+\b/g, (word) => {
        //   return word.length <= 3 ? word : word.charAt(0).toUpperCase() + word.slice(1);
        // }),
        UserName: values.UserName,
        Email: values?.Email,
        IdRol: values?.Roles.IdRol,
        IdStatus: values?.Estado.IdStatus,
        IdUser: values?.IdUser,
        IdPersonal: values.Personal?.CodigoPersonal,
        IdPersonalInt: values.Personal?.IdPersonal,
        IdTipoActivo: values.Type?.IdType,
        IdSubTipoActivo: values.SubType?.IdType,
        IdsAreas: values?.Areas?.map(area => area.IdArea).join(',')
      };

      const userExists = usuariosExistentes.find(
        (existingUser) =>
          existingUser.Usuario === user.Usuario &&
          existingUser.IdUser !== user.IdUser
      );
      const codigoExists = usuariosExistentes.find(
        (existingUser) =>
          existingUser.IdPersonal === user.CodigoPersonal &&
          existingUser.IdUser !== user.IdUser
      );
      if (userExists || codigoExists) {
        toastShow(
          toast,
          "error",
          "Usuario Existente",
          "El usuario o codigo ya existe en la base de datos.",
          3000
        );
        setLoading1(false);
        return;
      }

      const res = await updateUser(user);

      if (res[0].ESTADO === 1) {
        setLoading1(true);
        toastShow(toast, "success", "Modificado", res[0].MENSAJE);
        getUsers();
        setTimeout(() => {
          onHide();
          setLoading1(false);
        }, 2000);
      } else {
        toastShow(toast, "error", "Error", res[0].MENSAJE);
      }

      if (values?.Password) {
        const passwordUser = {
          Password: await encryptor(values?.ConfirmarPassword),
          IdUser: await encryptor(values?.IdUser + ""),
        };
        const res = await updatePassword(passwordUser);
        if (res?.code === "EREQUEST") {
          toastShow(
            toast,
            "error",
            "Error",
            "Error al modificar el contraseña"
          );
          setLoading1(false);
        } else {
          setLoading1(true);
          getUsers();
          toastShow(
            toast,
            "success",
            "Modificdo",
            "Contraseña Modificada Correctamente."
          );
          setTimeout(() => {
            onHide();
            setLoading1(false);
          }, 2000);
        }
      }
    }
  };

  const passwordHeader = <h6>Elige Tu Contraseña</h6>;

  const passwordFooter = (
    <React.Fragment>
      <Divider />
      <p className="mt-2">Sugerencias</p>
      <ul className="pl-2 ml-2 mt-0" style={{ lineHeight: "1.5" }}>
        <li>Necesita 2 numeros</li>
        <li>Minimo 6 characters</li>
      </ul>
    </React.Fragment>
  );

  const onHide = () => {
    setUsuarioDialog(false);
    setShowDialog(false);
    setuserEdit(null);
    resetForm();
  };

  const referencia = {
    IdRef: userEdit?.IdUser,
    Codigo: userEdit?.IdPersonal,
  };

  const subirFirma = async (e) => {
    const archivosGuardados = await getArchivos();
    if(referencia.Codigo === undefined){
      toastShow(
        toast,
        "warn",
        "Advertencia",
        "Guarde el usuario antes de agregar la firma."
      );
    } else{

      const imagenCorrespondiente = archivosGuardados?.find( (archivo) => archivo.startsWith(userEdit?.IdPersonal) );

      if (imagenCorrespondiente) {
        toastShow(toast, "error", 'Error', "Solo se permite subir 1 firma.");
        return;
      }
  
      const inputs = [
        {
          name: "IdRef",
          type: "text",
          value: referencia.IdRef,
        },
        {
          name: "Codigo",
          type: "text",
          value: referencia.Codigo,
        },
      ];
      uploadHandlerFirma({ e, inputs, toast, ref: fileUpload, getArchivos });
      setImagenAgregada(true);
      getArchivos();
    }
  };

  const getArchivos = async () => {
    const a = await getFirmasPersonales(userEdit?.IdPersonal);
    if (a?.length > 0) {
        const imagenCorrespondiente = a.find(e => e.startsWith(userEdit?.IdPersonal));
        if (imagenCorrespondiente) {
          try {
            setListadoArchivos([imagenCorrespondiente]);
          } catch (error) {
            setListadoArchivos([]);
          }
        } else {
          setListadoArchivos([]);
        }
    } else {
      setListadoArchivos([]);
    }
    return a;
  };

  const descargarArchivo = async (nombre) => {
    const a = await descargarFirma(userEdit?.IdPersonal, nombre);
    downloadFile(a, nombre);
  };

  const eliminar = async (nombre) => {
    const a = await eliminarFirma(userEdit?.IdPersonal, nombre);
    toastShow(toast, "success", "Eliminado", "Firma eliminada correctamente.");
    setListadoArchivos(listadoArchivos.filter((archivo) => archivo !== nombre));
  };

  const verImagenes = async () => {
    if (imagenes.length === 0) {
      toastShow(
        toast,
        "warn",
        "Advertencia",
        "Este usuario no tiene firma."
      );
    } else {
      setShowModalImagenes(true);
    }
  };

  const getImagenes = async () => {
    const i = await getFirmasPersonales(userEdit?.IdPersonal);
    if (i?.length > 0) {
        const imagenCorrespondiente = i.find(e => e.startsWith(userEdit?.IdPersonal));
        if (imagenCorrespondiente) {
            try {
                const a = await mostrarFirma(userEdit?.IdPersonal, imagenCorrespondiente);
                setImagenes({ Codigo: userEdit?.IdPersonal, img: [a] });
            } catch (error) {
                console.error(error);
                setImagenes([]);
            }
        } else {
            setImagenes([]);
        }
    } else {
        setImagenes([]);
    }
};


  useEffect(() => {
    getImagenes();
    getArchivos()
  }, [userEdit]);

  // Footer del Modal Editar
  const userDialogFooter = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />
      <Button
        label="Modificar"
        icon="pi pi-check"
        className="p-button-text"
        onClick={editarUsuario}
        loading={loading1}
      />
    </React.Fragment>
  );

  const cerrarModal = () => {
    setShowModalImagenes(false);
  };

  useEffect(() => {
    if (userEdit) {
      getValoresIniciales();
      setUsuarioDialog(true);
      setValues({
        ...userEdit,
        IdStatus: userEdit.IdStatus || 1,
        StatusName: userEdit.StatusName || "Activo",
      });
    }
    if (userEdit) {
      setShowDialog(true);
    } else {
      setShowDialog(false);
    }
  }, [userEdit]);

  return (
    <div>
      <Dialog
        id="editModal1"
        visible={showDialog}
        header="Modificar Usuario"
        modal
        className="modal__contenedor modal__usuarios"
        footer={userDialogFooter}
        onHide={onHide}
        style={{ width: "900px", minHeight: "400px" }}

      >
        <div id="Dialog">
          <Loader loading={loading1} querySelector={"#Dialog"} />
          <Toast ref={toast} />
          <ConfirmDialog />
          <TabView>
            <TabPanel header="Datos Generales">
              <div className="d-flex align-items-center flex-wrap">
                <div className="modal__input-contenedor">
                  <div className="field col-4 me-2">
                    <span className="p-float-label">
                      <InputText
                        name="Usuario"
                        value={values?.Usuario}
                        onChange={handleInputChange}
                        style={{ width: "100%" }}
                        autoFocus
                        abelStyle={{
                          color: "gray",
                          textShadow: "0px 0px 1px white",
                        }}
                        className={error.Usuario ? "p-invalid" : ""}
                      />
                      <label htmlFor="Usuario">Usuario</label>
                    </span>
                  </div>

                  <div className="field col-4 me-2">
                    <span className="p-float-label">
                      <InputText
                        name="UserName"
                        value={values?.UserName}
                        onChange={handleInputChange}
                        style={{ width: "100%" }}
                        className={error.UserName ? "p-invalid" : ""}
                      />
                      <label htmlFor="UserName">Nombre</label>
                    </span>
                  </div>

                  <div className="field col-4 me-2">
                    <span className="p-float-label">
                      <InputText
                        name="Email"
                        value={values?.Email}
                        onChange={handleInputChange}
                        style={{ width: "100%" }}
                        className={error.Email ? "p-invalid" : ""}
                      />
                      <label htmlFor="Email">Correo</label>
                      {error.Email && (
                        <small className="p-error">
                          Correo electrónico iválido. E.g. example@email.com
                        </small>
                      )}
                    </span>
                  </div>
                </div>

                <div className="modal__input-contenedor">
                  <div className="field col-4 me-2">
                    <span className="p-float-label">
                      <AutoCompleteDropdown
                        name={"Roles"}
                        value={values?.Roles}
                        items={roles}
                        field={"Rol"}
                        label={"Rol"}
                        handleInputChange={handleInputChange}
                        abelStyle={{
                          color: "gray",
                          textShadow: "0px 0px 1px white",
                        }}
                        className={error.IdRol ? "p-invalid" : ""}
                      />
                    </span>
                  </div>

                  <div className="field col-4 me-2">
                    <span className="p-float-label">
                      <AutoCompleteDropdown
                        name={"Personal"}
                        value={values?.Personal}
                        items={personal}
                        field={"NombreConcatenado"}
                        label={"Codigo Personal"}
                        handleInputChange={handleInputChange}
                        abelStyle={{
                          color: "gray",
                          textShadow: "0px 0px 1px white",
                        }}
                        className={error.IdPersonal ? "p-invalid" : ""}
                      />
                    </span>
                  </div>

                  <div className="field col-4 me-2">
                    <span className="p-float-label">
                      <AutoCompleteDropdown
                        name={"Estado"}
                        value={values?.Estado}
                        items={estados}
                        field={"StatusName"}
                        label={"Estado"}
                        handleInputChange={handleInputChange}
                        abelStyle={{
                          color: "gray",
                          textShadow: "0px 0px 1px white",
                        }}
                        className={error.IdStatus ? "p-invalid" : ""}
                      />
                    </span>
                  </div>
                </div>

                <div className="modal__input-contenedor">
                  <div className="field col-4 me-2">
                    <span className="p-float-label">
                      <AutoCompleteDropdown
                        name={"Type"}
                        value={values?.Type}
                        items={types}
                        field={"Type"}
                        label={"Tipo Activo"}
                        handleInputChange={handleInputChange}
                        className={error.IdType ? "p-invalid" : ""}
                      />
                    </span>
                  </div>

                  {/*Sub Tipo Activo */}
                  <div className="field col-4 me-2">
                    <span className="p-float-label">
                      <AutoCompleteDropdown
                        name={"SubType"}
                        value={values?.SubType}
                        items={subTypes}
                        field={"Type"}
                        label={"Sub Tipo Activo"}
                        handleInputChange={handleInputChange}
                      />
                    </span>
                  </div>

                  {hiddenPassword && (
                    <div className="field col-4 me-2 accordion-demo">
                      <Accordion activeIndex={1} collapseIcon="pi pi-lock">
                        <AccordionTab header="Cambiar Contraseña">
                          <span className="p-float-label mt-3">
                            <Password
                              id="Password"
                              name="Password"
                              value={values?.Password}
                              onChange={handleInputChange}
                              toggleMask
                              style={{ width: "100%" }}
                              header={passwordHeader}
                              footer={passwordFooter}
                            />
                            <label htmlFor="Password"> Nuevo Password</label>
                          </span>

                          <span className="p-float-label mt-5">
                            <Password
                              id="ConfirmarPassword"
                              name="ConfirmarPassword"
                              value={values?.ConfirmarPassword}
                              onChange={handleInputChange}
                              toggleMask
                              style={{ width: "100%" }}
                              header={passwordHeader}
                              footer={passwordFooter}
                            />
                            <label htmlFor="Password">Confirmar Password</label>
                            {error.Password && (
                              <small className="p-error">
                                Las contraseñas no coinciden.
                              </small>
                            )}
                          </span>
                        </AccordionTab>
                      </Accordion>
                    </div>
                  )}
                </div>

                <div className="modal__input-contenedor">
                  <div className="field col-8">
                    <span className="p-float-label">
                      <MultiSelect
                        options={areas}
                        optionLabel={'Area'}
                        onChange={handleInputChange}
                        value={values?.Areas}
                        id="Areas"
                        name="Areas"
                        style={{ width: "100%"}}
                        filter
                        display="chip"
                        placeholder="Areas"
                      />
                      <label>Areas</label>
                    </span>
                  </div>
                </div>
              </div>
            </TabPanel>

            <TabPanel header="Agregar Firma">
              <div  className="d-flex align-items-center flex-wrap">
              <div className="modal__input-contenedor"> 
                <div className="field col-12 me-2">
                  <FileUpload
                      ref={fileUpload}
                      name="demo"
                      url="./upload"
                      multiple
                      customUpload
                      uploadHandler={subirFirma}
                      maxFileSize={40000000}
                    />
                    <div className="mt-3">
                      <div>
                        {listadoArchivos?.map((a, i) => (
                          <div
                            className="d-flex gap p-2 border mt-2"
                            style={{ alignItems: "center" }}
                            key={i}
                          >
                            <div className="col-10">{a}</div>
                            <Button
                              icon="pi pi-download"
                              onClick={() => descargarArchivo(a)}
                            />
                            <Button
                              icon="pi pi-trash"
                              severity="danger"
                              onClick={() => eliminar(a)}
                            />
                          </div>
                        ))}
                      </div>
                    </div>
                    <div style={{ top: 350, right: 22 }} className="d-flex justify-content-end">
                      <Button
                        className={"mt-3"}
                        label="Ver Firma"
                        onClick={() => verImagenes()}
                      />
                    </div>
                </div>
              </div>
              </div>
            </TabPanel>
          </TabView>
        </div>
      </Dialog>


      {/* Dialogo para mostrar imagenes */}
      <Dialog header={values ? userEdit?.UserName : ""} visible={showModalImagenes} onHide={cerrarModal} className="w-50">
        <div style={{ maxWidth: "100%" }}>
          {imagenes.Codigo && (
            <Carousel
              value={imagenes.img}
              circular
              showIndicators={true}
              itemTemplate={(item) => {
                return (
                  <div
                    className="d-flex"
                    style={{
                      justifyContent: "center",
                      alignItems: "center",
                      height: "600px",
                    }}
                  >
                    <img
                      src={"data:image/png;base64," + item}
                      alt="imagen"
                       style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }}
                    />
                  </div>
                );
              }}
            />
          )}
        </div>
      </Dialog>
    </div>
  );
};

export default ModalEditarUsuario;
